import { Action } from '../../../redux/redux.types';
import { MaybeUndef } from '../../../types/system';
import { FILE_MANAGER_ACTIONS } from './file-manager.actions';

export interface ExpandModeState {
  fileId: MaybeUndef<string>;
}

const defaultState: ExpandModeState = {
  fileId: undefined,
};

export const expandMode = (
  state: ExpandModeState = defaultState,
  { type, payload }: Action,
): ExpandModeState => {
  switch (type) {
    case FILE_MANAGER_ACTIONS.OPEN_EXPAND_MODE:
      return {
        fileId: payload,
      };

    case FILE_MANAGER_ACTIONS.CLOSE_EXPAND_MODE:
      return {
        fileId: undefined,
      };

    default:
      return state;
  }
};
